var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.display)?_c('div',{staticClass:"cc-products"},_vm._l((_vm.products),function(product){return _c('product',{key:_vm.calculateKey(product),attrs:{"product":product}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }